// eslint-disable-next-line import/prefer-default-export
export enum PasswordResetScreen {
  ENTER_NEW_PASSWORD,
  PASSWORD_CHANGED,
  INVALID_TOKEN,
}
